import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { BlogLoginResp } from 'src/app/components/interface/Blog/BlogLoginResp';
import { CompanyLoginResp } from 'src/app/components/interface/Company/CompanyLoginResp';
import { SubscriberLoginResp } from 'src/app/components/interface/Subscriber/SubscriberLoginResp';
import { RuntimeConfigService } from 'src/app/services/runtime-config.service';
import { SKIP_API_URL_REWRITE, SKIP_AUTH_HEADER } from './api-context';

@Injectable()
export class CommonInterceptor implements HttpInterceptor {
  private apiBaseUrl: string = '';

  private readonly authEndpointPattern = /\/Auth\/(SubscriberLogin|BlogLogin|CompanyLogin)/i;

  constructor(private cookieService: CookieService, private configService: RuntimeConfigService) {
    this.configService.apiUrl$.subscribe((url) => {
      this.apiBaseUrl = url;
    });
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const skipAuthHeader =
      request.context.get(SKIP_AUTH_HEADER) || this.authEndpointPattern.test(request.url);

    if (!skipAuthHeader) {
      let blogUserString = sessionStorage.getItem('blogUser');
      let companyUserString = sessionStorage.getItem('companyUser');
      let subscriberString = sessionStorage.getItem('subscriber');

      if (this.configService.isElectron) {
        subscriberString = subscriberString || localStorage.getItem('subscriber');
        blogUserString = blogUserString || localStorage.getItem('blogUser');
        companyUserString = companyUserString || localStorage.getItem('companyUser');
      }

      if (!subscriberString) {
        subscriberString = this.cookieService.get('subscriber');
      }

      if (blogUserString) {
        const user: BlogLoginResp = JSON.parse(blogUserString);
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${user.token}`,
          },
        });
      } else if (companyUserString) {
        const user: CompanyLoginResp = JSON.parse(companyUserString);
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${user.token}`,
          },
        });
      } else if (subscriberString) {
        const user: SubscriberLoginResp = JSON.parse(subscriberString);
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${user.token}`,
          },
        });
      }
    } else if (request.headers.has('Authorization')) {
      request = request.clone({
        headers: request.headers.delete('Authorization'),
      });
    }

    if (!request.context.get(SKIP_API_URL_REWRITE) && this.apiBaseUrl) {
      request = request.clone({
        url: request.url.replace('https://a-square-erp-service-a-square-erp-service-prod.azurewebsites.net/', this.apiBaseUrl)
      });
    }

    return next.handle(request);
  }
}
